(() => {
  if (customElements.get("product-video")) {
    return;
  }

  class ProductVideo extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        button: "[data-play-button]",
        video: "video",
        wrapper: "[data-videos-wrapper]",
      };
    }

    mute(event) {
      const video = event.detail.video;
      if (video === this.video) {
        return;
      }
      if (this.video.muted) {
        return;
      }
      this.video.muted = true;
      this.button.classList.remove("hidden");
    }

    toggleVideo() {
      const isMuted = this.video.muted;
      this.button?.classList.toggle("hidden", isMuted);
      this.video.muted = !isMuted;
      if (!isMuted) {
        return;
      }
      this.dispatchEvent(
        new CustomEvent("video-played", {
          bubbles: true,
          detail: {
            video: this.video,
          },
        })
      );
    }

    addListeners() {
      this.addEventListener("click", this.toggleVideo.bind(this));
      this.wrapper?.addEventListener("video-played", this.mute.bind(this));
    }

    connectedCallback() {
      this.button = this.querySelector(this.selectors.button);
      this.video = this.querySelector(this.selectors.video);
      this.wrapper = this.closest(this.selectors.wrapper);

      if (!this.button || !this.video) {
        return;
      }

      this.addListeners();
    }
  }

  customElements.define("product-video", ProductVideo);
})();
